module.exports = __webpack_public_path__ + "img/m8.2ccc1a4f.png";